import { render } from "./autocomplete.vue?vue&type=template&id=6451b964&scoped=true&ts=true"
import script from "./autocomplete.vue?vue&type=script&lang=ts"
export * from "./autocomplete.vue?vue&type=script&lang=ts"

import "./autocomplete.vue?vue&type=style&index=0&id=6451b964&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6451b964"]])

export default __exports__